import { Card, CardActionArea, CardContent, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

import {
  VEHICLE_TYPE_ICONS,
  VEHICLE_TYPE_TEST_IDS
} from "@/src/components/atoms/VehicleSelectCard/vehicleSelectCard.constants";

import { VehicleType } from "@/src/types/types";

interface VehicleSelectCardWizardViewProps {
  selectedVehicleType: VehicleType;
  onVehicleTypeChange: (value: VehicleType) => void;
  vehicleLabel: string;
  vehicleType: VehicleType;
}

const buildCardSx = (isSelected: boolean) => ({
  backgroundColor: isSelected
    ? theme.palette.common.white
    : theme.palette.semantic.secondary.selected,
  transition: "background-color 0.3s, box-shadow 0.3s",
  width: "100%",
  borderRadius: "1.25rem 1.25rem 0rem 0rem",
  border: isSelected
    ? `1px solid ${theme.palette.text.primary}`
    : theme.palette.common.white,
  borderBottom: isSelected ? "none" : `1px solid ${theme.palette.text.primary}`,
  p: 0.5,
  py: 0
});

const cardActionAreaSx = {
  height: "100%",
  minWidth: 0,
  display: "flex",
  alignItems: "stretch",
  ".MuiCardActionArea-focusHighlight": {
    backgroundColor: "transparent"
  }
};

const cardContentSx = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
  px: { xs: 0.75, sm: 1 },
  py: { xs: 0.25, sm: 0.5 },
  gap: { xs: "0", sm: "0" },
  minWidth: { xs: "100%", sm: "180px", md: "180px" },
  height: { xs: "55px", sm: "76px" }
};

const buildIconSx = (isSelected: boolean) => ({
  width: { xs: 28, sm: 30 },
  height: { xs: 28, sm: 30 },
  fontSize: { xs: 28, sm: 30 },
  color: isSelected ? theme.palette.common.black : theme.palette.text.secondary
});

const buildLabelSx = (isSelected: boolean) => ({
  color: isSelected ? theme.palette.common.black : theme.palette.text.secondary,
  lineHeight: 1.25,
  fontSize: { xs: "0.875rem", sm: "1.125rem" }
});

const VehicleSelectCardWizardView = (
  props: VehicleSelectCardWizardViewProps
) => {
  const {
    vehicleType,
    selectedVehicleType,
    onVehicleTypeChange,
    vehicleLabel
  } = props;
  const isSelected = selectedVehicleType === vehicleType;
  const VehicleIcon = VEHICLE_TYPE_ICONS[vehicleType];

  return (
    <Card
      raised={isSelected}
      sx={buildCardSx(isSelected)}
      elevation={0}
      data-testid={VEHICLE_TYPE_TEST_IDS[vehicleType]}
    >
      <CardActionArea
        onClick={() => onVehicleTypeChange(vehicleType)}
        sx={cardActionAreaSx}
      >
        <CardContent sx={cardContentSx}>
          <VehicleIcon sx={buildIconSx(isSelected)} />
          <Typography variant="subtitle1" sx={buildLabelSx(isSelected)}>
            {vehicleLabel}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default VehicleSelectCardWizardView;
